export class LoadGlobalLanguagesList {
  static readonly type = '[Global] Load Languages List';
}

export class LoadGlobalLanguagesListError {
  static readonly type = '[Global] Load Languages List Error';
}
